import { useEffect, useState } from 'react';
import { api } from '../api';

export function SettingsPage() {
  const [me, setMe] = useState<{ workspace_id: string; actor: any } | null>(null);

  useEffect(() => {
    void api.me().then(setMe).catch(() => undefined);
  }, []);

  return (
    <div className="p-8 max-w-3xl">
      <h1 className="text-2xl font-semibold mb-6">Settings</h1>

      <section className="card p-5 mb-4">
        <h2 className="text-sm font-semibold mb-3 text-text-muted uppercase tracking-wider">
          Account
        </h2>
        {me ? (
          <dl className="text-sm space-y-2">
            <Row label="Workspace" value={me.workspace_id} mono />
            <Row label="Your user ID" value={(me.actor as any)?.userId ?? '—'} mono />
            <Row label="Role" value={(me.actor as any)?.role ?? '—'} />
          </dl>
        ) : (
          <div className="text-text-dim text-sm">Loading…</div>
        )}
      </section>

      <section className="card p-5 mb-4">
        <h2 className="text-sm font-semibold mb-3 text-text-muted uppercase tracking-wider">
          Status
        </h2>
        <p className="text-sm text-text-muted">
          TheHub is at <code className="text-accent">v0.1</code> — foundation is live, more features
          coming. See the{' '}
          <a
            href="https://github.com/normanknoche/thehub"
            target="_blank"
            rel="noreferrer"
            className="text-accent hover:underline"
          >
            GitHub repo
          </a>{' '}
          for the master plan and roadmap.
        </p>
      </section>

      <section className="card p-5">
        <h2 className="text-sm font-semibold mb-3 text-text-muted uppercase tracking-wider">
          Sign out
        </h2>
        <p className="text-sm text-text-muted mb-3">
          Signed in via Cloudflare Access. Click below to clear the Access session.
        </p>
        <a
          href="/cdn-cgi/access/logout"
          className="btn"
        >
          Sign out
        </a>
      </section>
    </div>
  );
}

function Row({ label, value, mono }: { label: string; value: string; mono?: boolean }) {
  return (
    <div className="flex">
      <dt className="w-40 text-text-muted">{label}</dt>
      <dd className={mono ? 'font-mono text-xs' : ''}>{value}</dd>
    </div>
  );
}
